import { render, staticRenderFns } from "./ButtonGrouped.vue?vue&type=template&id=01a8be6a&scoped=true&"
import script from "./ButtonGrouped.vue?vue&type=script&lang=js&"
export * from "./ButtonGrouped.vue?vue&type=script&lang=js&"
import style0 from "./ButtonGrouped.vue?vue&type=style&index=0&id=01a8be6a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01a8be6a",
  null
  
)

export default component.exports